'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_RecipeEditor$State(recipeParsingResults, unitOptions, cuisines, categories, mainCategories, newIngredient, errorModalOpen, showRawRecipe, savedSelectionHtml, savedSelectionText, contextMenuDisabled) {
  this.cY = null;
  this.mv = null;
  this.nu = null;
  this.ln = null;
  this.ms = null;
  this.nw = null;
  this.nv = false;
  this.mu = false;
  this.mt = null;
  this.k4 = null;
  this.nt = false;
  this.cY = recipeParsingResults;
  this.mv = unitOptions;
  this.nu = cuisines;
  this.ln = categories;
  this.ms = mainCategories;
  this.nw = newIngredient;
  this.nv = errorModalOpen;
  this.mu = showRawRecipe;
  this.mt = savedSelectionHtml;
  this.k4 = savedSelectionText;
  this.nt = contextMenuDisabled;
}
export { $c_Lmealorama_components_RecipeEditor$State as $c_Lmealorama_components_RecipeEditor$State };
$p = $c_Lmealorama_components_RecipeEditor$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_RecipeEditor$State;
/** @constructor */
function $h_Lmealorama_components_RecipeEditor$State() {
}
export { $h_Lmealorama_components_RecipeEditor$State as $h_Lmealorama_components_RecipeEditor$State };
$h_Lmealorama_components_RecipeEditor$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 80204913);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.cY));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mv));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.nu));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.ln));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.ms));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.nw));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.nv ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.mu ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mt));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.k4));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.nt ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 11);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_RecipeEditor$State)) {
    if ((((this.nv === x$0.nv) && (this.mu === x$0.mu)) && (this.nt === x$0.nt))) {
      var x = this.cY;
      var x$2 = x$0.cY;
      var $x_7 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$3 = this.mv;
      var x$4 = x$0.mv;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.nu;
      var x$6 = x$0.nu;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.ln;
      var x$8 = x$0.ln;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.ms;
      var x$10 = x$0.ms;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.nw;
      var x$12 = x$0.nw;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.mt;
      var x$14 = x$0.mt;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.k4;
      var x$16 = x$0.k4;
      return ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 11;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.cY;
      break;
    }
    case 1: {
      return this.mv;
      break;
    }
    case 2: {
      return this.nu;
      break;
    }
    case 3: {
      return this.ln;
      break;
    }
    case 4: {
      return this.ms;
      break;
    }
    case 5: {
      return this.nw;
      break;
    }
    case 6: {
      return this.nv;
      break;
    }
    case 7: {
      return this.mu;
      break;
    }
    case 8: {
      return this.mt;
      break;
    }
    case 9: {
      return this.k4;
      break;
    }
    case 10: {
      return this.nt;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_components_RecipeEditor$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ki)));
}
export { $isArrayOf_Lmealorama_components_RecipeEditor$State as $isArrayOf_Lmealorama_components_RecipeEditor$State };
var $d_Lmealorama_components_RecipeEditor$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_RecipeEditor$State, "mealorama.components.RecipeEditor$State", ({
  ki: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_RecipeEditor$State as $d_Lmealorama_components_RecipeEditor$State };
//# sourceMappingURL=mealorama.components.-Recipe-Editor$-State.js.map
